import getPlayfieldPosition from './playfieldPosition';
import './BossShip.css';

function BossShip({ boss }) {
  if (!boss) {
    return null;
  }

  const healthPercent = Math.max(0, Math.min(100, (boss.health / boss.maxHealth) * 100));
  const className = [
    'boss-ship',
    boss.hitFlashMs > 0 ? 'boss-ship-hit' : '',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={className}
      style={getPlayfieldPosition(boss.x, boss.y)}
      aria-label={`${boss.name} health ${boss.health} of ${boss.maxHealth}`}
    >
      <span className="boss-escort boss-escort-left" />
      <span className="boss-escort boss-escort-right" />
      <img src={`${process.env.PUBLIC_URL}/enemy-ship.png`} alt="" />
      <span className="boss-core-glow" />
      <div className="boss-health" aria-hidden="true">
        <span style={{ width: `${healthPercent}%` }} />
      </div>
    </div>
  );
}

export default BossShip;
